import { Injectable } from '@angular/core';
import * as _ from 'smartystreets-javascript-sdk';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class AddressLookupService {

  constructor(private configService: ConfigService) { }

  // using sdk
  public AutocompleteAddress(search: string, filterZipcode:string = "", selected:string= ""): Promise<any> {
    const SmartyStreetsSDK = _; 
    const SmartyStreetsCore = SmartyStreetsSDK.core;
    const websiteKey = this.configService.config.smartyStreetApiKey ?? '109841188408014926'; // Website Key
    const Lookup = SmartyStreetsSDK.usAutocompletePro.Lookup;
    const credentials = new SmartyStreetsCore.SharedCredentials(websiteKey);
    const clientBuilder = new SmartyStreetsCore.ClientBuilder(credentials);
    const client = clientBuilder.buildUsAutocompleteProClient();
    const lookup = new Lookup(search);
    if (filterZipcode.length > 0)
      lookup.includeOnlyZIPCodes = [filterZipcode];
    if (selected.length > 0)
      lookup.selected = selected;
    return client.send(lookup);
  }
}


